import { afterMethod } from "./decorators";
export var onException = function (advice) { return afterMethod(function (meta) { return meta.exception && advice(meta); }); };
//# sourceMappingURL=on-exception.js.map